var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 3.41667C12.2999 3.41667 14.1666 5.28333 14.1666 7.58333C14.1666 8.00833 14.0833 8.41667 13.9666 8.8L16.5166 11.35C17.6749 10.325 18.5916 9.04167 19.1666 7.575C17.7249 3.925 14.1666 1.33333 9.99992 1.33333C8.94158 1.33333 7.92492 1.5 6.96658 1.80833L8.77492 3.61667C9.16658 3.5 9.57492 3.41667 9.99992 3.41667ZM2.25825 0.633334C1.93325 0.958334 1.93325 1.48333 2.25825 1.80833L3.89992 3.45C2.54992 4.525 1.47492 5.94167 0.833252 7.58333C2.27492 11.2417 5.83325 13.8333 9.99992 13.8333C11.2666 13.8333 12.4749 13.5833 13.5916 13.15L15.8583 15.4167C16.1833 15.7417 16.7083 15.7417 17.0333 15.4167C17.3583 15.0917 17.3583 14.5667 17.0333 14.2417L3.44159 0.633334C3.11659 0.308334 2.58325 0.308334 2.25825 0.633334ZM9.99992 11.75C7.69992 11.75 5.83325 9.88333 5.83325 7.58333C5.83325 6.94167 5.98325 6.33333 6.24158 5.8L7.54992 7.10833C7.52492 7.25833 7.49992 7.41667 7.49992 7.58333C7.49992 8.96667 8.61658 10.0833 9.99992 10.0833C10.1666 10.0833 10.3166 10.0583 10.4749 10.025L11.7833 11.3333C11.2416 11.6 10.6416 11.75 9.99992 11.75ZM12.4749 7.30833C12.3499 6.14167 11.4333 5.23333 10.2749 5.10833L12.4749 7.30833Z",
    fill: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.1531db7ca0807a267df8daba63d47f5d.svg";
export { ForwardRef as ReactComponent };